module.exports = __webpack_public_path__ + "static/media/nav_gachaeb47f07b0a0a071a6104daf2973e436c.webp";